/** @format */
import { getConfig } from '@toucan/common/services/nextjs/settings';

const { publicRuntimeConfig } = getConfig();
export function getStaticImageUrl(imagePath?: string) {
    return `${publicRuntimeConfig?.assetPrefix ?? ''}${imagePath}`;
}
